import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    routes:[],
    username:"thuc vuex",
    level:0,
  },
  getters: {
    getUsername(state){
      return state.username;
    }
    //let x=store.getters.getUsername
  },
  mutations: {
    setUsername(state,str){
      state.username=str;
    }
    //store.commit('setUsername',"thuc 101")
  },
  actions: {
  },
  modules: {
  }
})
